<script>
import { searchState } from "../Store/SearchStateStore"
import { fade, fly } from 'svelte/transition'
import { onDestroy, onMount } from "svelte"
import { overlay } from "../Store/OverlayStore"
import Spinner from "./Spinner.svelte"
import LocationList from "./LocationList.svelte"
import Search from "./Search.svelte"
import { allLocations, contextLocations } from "../Store/LocationStores";


let previousFocus
let overlayElement


const onSearch = e => {
    if ( e.detail.query === '' ) {
        searchState.setReady()
    } else {
        searchState.setSearching()
    }
}

const onSearchCancel = () => {
    searchState.setReady()
}

const hideOverlay = () => {
    overlay.hide()
    previousFocus?.focus()
}

const trapFocusForKeyboardUsers = (e) => {
    // Prevent keyboard users from "tabbing" out of the modal or focusing on elements behind the modal

    // Only active for "tabbing".
    if ( ! overlayElement || e.key !== 'Tab' ) {
        return;
    }

    // Focusable elements in our modal
    const focusableElements = overlayElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )

    if ( ! focusableElements ) {
        return
    }

    // Define the bounds of our loop
    const firstElement = focusableElements[0]  // First focusable element
    const lastElement = focusableElements[focusableElements.length - 1]  // Last focusable element
    //console.log( 'trap:', firstElement, lastElement )

    // Our "loop" is effectively the "close" button to the last "region".

    // Force users to tab within our "loop".
    if ( e.shiftKey ) {
        // Backward
        if ( document.activeElement === firstElement ) {
            lastElement?.focus()
            e.preventDefault()
        }

    } else {
        // Forward
        if ( document.activeElement === lastElement ) {
            firstElement?.focus()
            e.preventDefault()
        }
    }
}

const onKeydown = (e) => {
    if ( e.key === 'Escape' ) {
        hideOverlay()
    }

    if ( e.key === 'Tab' ) {
        trapFocusForKeyboardUsers(e)
    }
}


// lifecyle
onMount(() => {
    previousFocus = document.activeElement
    overlayElement?.focus()
    document.addEventListener('keydown', onKeydown)
})

onDestroy(() => {
    overlay.hide()
    searchState.setReady()
    document.removeEventListener('keydown', onKeydown)
})


// reactive
$: title = $overlay.context && $overlay.context.page_title || ''
$: eyebrow = $overlay.context && $overlay.context.page_eyebrow || ''

</script>

<div class="cul-overlay__outer"
     bind:this={overlayElement}
     data-context="{$overlay.context.id}"
     role="dialog"
     aria-modal="true"
     aria-labelledby="cul-overlay-title"
     aria-describedby="cul-overlay-content"
     tabindex="-1"
>

    <div class="cul-overlay__bg"
         aria-hidden="true"
         on:click={hideOverlay}
         transition:fade></div>

    <div class="cul-overlay__inner" transition:fly={{ x: -100}}>

        {#if ! $allLocations.length}
            <div role="status" aria-live="polite" aria-label="Loading Locations ...">
                <Spinner/>
            </div>
        {:else}
            <div class="cul-overlay__header">
                <div class="cul-overlay__eyebrow">{eyebrow}</div>

                <div id="cul-overlay-title" class="cul-overlay__title">{title}</div>

                <button type="button"
                        on:click={hideOverlay}
                        aria-label="Close Locations List"
                >
                    <svg aria-hidden="true" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.40234 6.69927L6.28984 4.81177L27.5973 26.1193L25.7098 28.0068L4.40234 6.69927Z" fill="#fff"/>
                        <path d="M4.40234 26.1193L25.7098 4.81177L27.5973 6.69927L6.28984 28.0068L4.40234 26.1193Z" fill="#fff"/>
                    </svg>
                </button>
            </div>


            <div id="cul-overlay-content" class="cul-overlay__content">

                <Search
                        locations={$contextLocations}
                        on:search-query={onSearch}
                        on:search-cancel={onSearchCancel}
                />

                {#if $searchState === 's-ready'}
                    <LocationList locations={$contextLocations} />
                {/if}
            </div>

            <div class="cul-overlay__footer">
            </div>

        {/if}
    </div>
</div>
